module.exports = `fragment vendor_integrations on Contentstack_vendor_integrations {
    jane_med_id
    jane_rec_id
    jane_is_sandbox
    aiq_medical_id
    aiq_rec_id
  }`;